import {Module} from 'vuex';
import {RootState} from '../types';
import {ListsState} from './types';
import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';
import i18n from "@/plugins/i18n";

export const state: ListsState = {
  originatorStatusList: [
    {text: 'Разрешен', value: 'ACCEPTED'},
    {text: 'На рассмотрении', value: 'UNDER_CONSIDERATION'},
    {text: 'Запрещен', value: 'DENIED'},
  ],
  templatesStatusList: [
    {text: 'Ожидает модерации', value: 'ForModeration'},
    {text: 'На модерации', value: 'OnModeration'},
  ],
  messagesStatusList: [
    'Failed',
    'Rejected',
    'NotDelivered',
    'Delivered',
    'Deferred',
    'Expired',
    'Transmitted',
  ],
  pushMessagesStatusList: [
    'Delivered',
    'Read',
    'NotDelivered',
    'Transmitted',
    'Failed',
    'Rejected',
    'Expired',
    'Deferred',
  ],
  smsMessagesStatusList: [
    'Error',
    'Processed',
  ],
  callMessagesStatusList: [
    'Error',
    'Finished',
    'Rejected',
    'NotAnswered',
    'Buffered',
  ],
  emailMessagesStatusList: [
    'Delivered',
    'Read',
    'NotDelivered',
    'Transmitted',
    'Failed',
    'Rejected',
    'Deferred',
  ],
  viberMessagesStatusList: [
    'Delivered',
    'Read',
    'NotDelivered',
    'Transmitted',
    'Expired',
    'Failed',
    'Rejected',
    'Deferred',
  ],
  whatsappMessagesStatusList: [
    'Delivered',
    'Read',
    'NotDelivered',
    'Transmitted',
    'Expired',
    'Failed',
    'Rejected',
    'Deferred',
  ],
  customMessagesStatusList: [
    'Delivered',
    'Read',
    'NotDelivered',
    'Transmitted',
    'Expired',
    'Failed',
    'Rejected',
    'Deferred',
  ],
  mnMessagesStatusList: [
    'Failed',
    'Rejected',
    'NotDelivered',
    'Delivered',
    'Deferred',
    'Expired',
    'Transmitted',
    'Read',
  ],
  priorityList: [
    {text: 'Low', value: 2},
    {text: 'Normal', value: 4},
    {text: 'High', value: 6},
    {text: 'Realtime', value: 8},
  ],
  deliveryTypeList: [
    {text: 'Native Push', value: 'native'},
    {text: 'Web Push', value: 'web'},
    {text: 'Native Push и Web Push', value: 'web-and-native'},
  ],
  smsFilterConditionsList: [
    {text: 'Равно', value: 'eq'},
    {text: 'Не равно', value: '!eq'},
    {text: 'Содержит', value: 'in'},
    {text: 'Не содержит', value: '!in'},
    {text: 'Удовлетворяет регулярному выражению', value: 'is_regex'},
  ],
  delimiterList: [
    {text: 'comma', value: ','},
    {text: 'semicolon', value: ';'},
    {text: 'space', value: 'space'},
  ],
  restrictionsList: [
    {text: 'Только буквенные', value: 'alpha'},
    {text: 'Только числовые', value: 'numeric'},
    {text: 'Заданные', value: 'allowed'},
  ],
  devicesList: [
    {text: 'ALL', value: 'ALL'},
    {text: 'ONLY_LAST', value: 'ONLY_LAST'},
  ],
  personalisationList:[
    {name: i18n.t('variable.number'),value: '$phone'},
    {name: 'Email',value: '$email'},
    {name: i18n.t('variable.name'),value: '$name'},
    {name: i18n.t('variable.surname'),value: '$surname'},
    {name: i18n.t('variable.patronymic'),value: '$middlename'},
    ...Array.from(Array(6).keys()).map(i => i + 1).map(i => ({
      name: i18n.t(`variable.field_${i}`),
      value: `$field${i}`
    }))
  ],
  xiaomiRegionList: [
    'China',
    'Europe',
    'Russia',
    'India',
    'Singapore',
    'Other'
  ],
  positionList: ['preproc', 'preroute'],
  timezonesList: [
    {id: 1, name: "UTC(0)"},
    {id: 2, name: "UTC+1"},
    {id: 3, name: "UTC+2"},
    {id: 4, name: "UTC+3"},
    {id: 5, name: "UTC+4"},
    {id: 6, name: "UTC+5"},
    {id: 7, name: "UTC+6"},
    {id: 8, name: "UTC+7"},
    {id: 9, name: "UTC+8"},
    {id: 10, name: "UTC+9"},
    {id: 11, name: "UTC+10"},
    {id: 12, name: "UTC+11"},
    {id: 13, name: "UTC+12"},
    {id: 14, name: "UTC-1"},
    {id: 15, name: "UTC-2"},
    {id: 16, name: "UTC-3"},
    {id: 17, name: "UTC-4"},
    {id: 18, name: "UTC-5"},
    {id: 19, name: "UTC-6"},
    {id: 20, name: "UTC-7"},
    {id: 21, name: "UTC-8"},
    {id: 22, name: "UTC-9"},
    {id: 23, name: "UTC-10"},
    {id: 24, name: "UTC-11"},
  ],
  eventTypeList: [
    'opening',
    'unsubscribing',
    'subscribing',
    'following_link',
  ],
  cdpStatusList: [
    'New',
    'Processed',
    'Error'
  ],
};


export const lists: Module<ListsState, RootState> = {
  state,
  getters,
  actions,
  mutations
};
